import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import linkImage from '../../assets/icons/Link.svg';
import {
  BodyText,
  MinorHeading,
  Subtitle
} from '../../components/shared/typography/PrimaryTypography';
import PrimaryButton from '../../components/shared/button/PrimaryButton';
import { OpenInNew } from '@mui/icons-material';

/**
 * Landing page shown when an invitation / password-set link has expired.
 * Offers two recovery paths: navigate to `/recover-password` to request a
 * fresh reset email, or email support directly.
 */
function ExpiredLink(): JSX.Element {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh'
      }}
    >
      <Card
        sx={{
          maxWidth: 480,
          width: '100%',
          p: 4,
          borderRadius: 4,
          boxShadow: 'none',
          border: 'none'
        }}
        elevation={0}
      >
        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={linkImage} width={180} style={{ marginBottom: 32 }} />
          <Subtitle weight="Bold" sx={{ mb: 3, fontSize: '2.2rem', textAlign: 'center' }}>
            This link is no longer available
          </Subtitle>
          <BodyText sx={{ mb: 6, textAlign: 'center', color: 'text.secondary' }}>
            The password set-up link has already been used, or the expiry time has been exceeded.
            Please reset your password using the link below, or contact Energy Partners if you
            experience further issues.
          </BodyText>
          <Grid container spacing={2} sx={{ width: '100%' }}>
            <Grid size={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <PrimaryButton sx={{ px: 6 }} onClick={() => navigate('/recover-password')}>
                Reset Password
              </PrimaryButton>
            </Grid>
            <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', pt: 3 }}>
              <a
                href="mailto:platformsupport@energypartners.co.za"
                style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 2 }}
              >
                <MinorHeading
                  weight="Medium"
                  sx={{ color: theme.palette.teal.main, fontSize: '0.9rem' }}
                >
                  Contact Support
                </MinorHeading>
                <OpenInNew sx={{ fontSize: '0.9rem', color: theme.palette.teal.main }} />
              </a>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}

export default ExpiredLink;
